/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give each requirement an observable pass condition. Instead of writing “good compatibility,” write “the saved file opens in the recipient’s Excel without a repair prompt, and these three formulas match.” Instead of “easy sharing,” write down who edits, who only reads and how everyone finds the current version. Evaluate both products against the same conditions rather than relying on a general feature count.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为每项需求写下可观察的通过条件。例如，不写笼统的“兼容性好”，而写“保存的文件在接收者的 Excel 中打开不提示修复，且三条指定公式结果一致”。对于分享，应明确谁编辑、谁只读，以及如何确认最新版本。用相同条件评估两款产品，而不是只比较功能数量。`)
};

/**
* | output |
* | --- |
* | "Give each requirement an observable pass condition. Instead of writing “good compatibility,” write “the saved file opens in the recipient’s Excel without a r..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_1 as "gc.search_guides.gridcraft_vs_excel.sections.5.paragraphs.1" }